export default __webpack_public_path__ + "static/media/notificacion-turno.5d0b7113.png";